import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { LaboratoryExaminationMethodListItem } from "../../shared/models/laboratory/laboratory-examination-method-list-item";
import { LaboratoryExaminationMethodDto } from "../../shared/models/laboratory/laboratory-examination-method.dto";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { ActionResult } from "../../shared/models/core/ActionResult";

@Injectable()
export class LaboratoryExaminationMethodsService extends DataService<LaboratoryExaminationMethodListItem, LaboratoryExaminationMethodDto> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratory-examination-methods';
    }

    updateAssignedUser(laboratoryExaminationMethodId: number, assignedPerformerUserId: number): Observable<any> {
        return this.putQuery(`${this.baseUrl()}/update-assigned-user`, {
            laboratoryExaminationMethodId: laboratoryExaminationMethodId,
            assignedPerformerUserId: assignedPerformerUserId
        });
    }
}